import { Box, Container, InputLabel } from '@material-ui/core'
import RegularButton from 'components/CustomButtons/Button'
import { convertToMapById } from 'helpers/convertToMap'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ReactSelect from 'react-select'
import { sendConfigUnitV2 } from 'redux/actions/unitsSection/unitsAction'
import { createSelector } from 'reselect'

const brandsSelector = createSelector((state) => {
  return Object.keys(state.brandsReducer.brands).length > 0 ? convertToMapById(state.brandsReducer.brands).filter(br => br.idStation === state.unitsReducer.station?.id) : []
}, brands => brands)

export const AddStationBrands = (props) => {
  const {
    data,
    onClose
  } = props
  const brands = useSelector(state => brandsSelector(state))
  const { token } = useSelector(({ login }) => login)
  const dispatch = useDispatch()
  const [brand, setBrand] = useState({})

  const handleNewBrand = (e) => {
    setBrand(e)
  }
  const sendConfig = () => {
    const body = {
      idStationBrand: brand.id
    }
    dispatch(sendConfigUnitV2(data.id, body));
    setTimeout(() => {
      onClose()
    }, 400);
  }

  useEffect(() => {
    setBrand(brands.filter(br => br.id === data.idStationBrand))
  }, [data.idStationBrand, brands])
  console.log('data', data)
  return (
    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '20rem' }}>
      <Container>
        <InputLabel htmlFor="select-brand" style={{
          marginBottom: 16
        }}>
          Centro de costos
        </InputLabel>
        <ReactSelect
          id="select-brand"
          value={brand}
          options={brands}
          onChange={handleNewBrand}
        />
      </Container>
      <Box style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, width: '80%', margin: '0 auto' }}>
        <RegularButton color="danger" onClick={onClose}>Cancelar</RegularButton>
        <RegularButton color="success" onClick={sendConfig} tooltip={`Guardar - ${brand.label}`}>Guardar</RegularButton>
      </Box>
    </Box>
  )
}
